module.exports = __webpack_public_path__ + "img/scene-5.06afd12.png";